
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"225mm","height":"225mm","viewBox":"0 0 225 225"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M112.255 2.698A109.802 109.802 0 002.698 112.5 109.802 109.802 0 00112.5 222.302 109.802 109.802 0 00222.302 112.5 109.802 109.802 0 00112.5 2.698a109.802 109.802 0 00-.245 0zm-.63 46.718h1.75c8.31 0 15 6.69 15 15v50.698c0 8.31-6.69 15-15 15h-1.75c-8.31 0-15-6.69-15-15V64.416c0-8.31 6.69-15 15-15zm.875 94.418a15.875 15.875 0 0115.875 15.875 15.875 15.875 0 01-15.875 15.875 15.875 15.875 0 01-15.875-15.875 15.875 15.875 0 0115.875-15.875z","fill":"red"}})])
          )
        }
      }
    